<template>
  <div>
    <el-radio-group v-model="listXuan.id">
      <el-radio
      style="margin-bottom:10px"
        v-for="(item,index) in listHttps"
        :key="index"
        :label="item.id"
        @change="changeSkipType(item)"
      >{{ item.name}}</el-radio>
    </el-radio-group>
    <el-form :model="form">
      <!-- 1.商品分类 -->
      <el-form-item v-if="listXuan.paramType === '1'" label="商品分类：">
        <el-select
          v-model="listXuan.value"
          placeholder="请选择启用的商品分类名称"
          @change="onInputBlur"
        >
          <el-option
            v-for="classItem in listClass"
            :key="classItem.id"
            :label="classItem.name"
            :value="classItem.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 2商品skuid -->
      <el-form-item v-if="listXuan.paramType === '2'" label="商品skuId：">
        <el-input
          @blur="onInputBlur(listXuan.value)"
          v-model="listXuan.value"
          clearable
          style="max-width:445px"
        />
      </el-form-item>
      <!-- 3优惠券id -->
      <el-form-item v-if="listXuan.paramType === '3'" label="优惠券Id：">
        <el-input
          @blur="onInputBlur(listXuan.value)"
          v-model="listXuan.value"
          clearable
          style="max-width:445px"
        />
      </el-form-item>
      <!-- 4.装修内页 -->
      <el-form-item v-if="listXuan.paramType === '4'" label="装修内页：">
        <el-select
          v-model="listXuan.value"
          placeholder="请选择启用的装修内页名称"
          @change="onInputBlur"
        >
          <el-option
            v-for="subItem in listData"
            :key="subItem.id"
            :label="subItem.name"
            :value="subItem.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 5文章id -->
      <el-form-item v-if="listXuan.paramType === '5'" label="文章id：">
        <el-input
          @blur="onInputBlur(listXuan.value)"
          v-model="listXuan.value"
          clearable
          style="max-width:445px"
        />

      </el-form-item>

      <!-- 地图页列表 -->
      <el-form-item v-if="listXuan.paramType === '7'" label="地图页：">
        <el-select
            v-model="listXuan.value"
            placeholder="请选择地图页面名称"
            @change="onInputBlur"
        >
          <el-option
              v-for="subItem in mapPageList"
              :key="subItem.id"
              :label="subItem.name"
              :value="subItem.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 智能助手 -->
      <el-form-item v-if="listXuan.paramType === '8'" label="回复内容：">
        <el-select
            v-model="listXuan.value"
            filterable
            remote
            @change="onInputBlur"
            reserve-keyword
            placeholder="搜素回复"
            :remote-method="getReplyList"
            :loading="replyOptionLoading"
        >
          <el-option
              v-for="option in replyList"
              :key="option.key"
              :label="option.value"
              :value="option.key"
          />
        </el-select>
      </el-form-item>

<!--   9 任务标签   -->
      <el-form-item v-if="listXuan.paramType === '9'" label="任务标签：">
        <el-select
            v-model="listXuan.value"
            placeholder="请选择任务标签"
            @change="onInputBlur"
        >
          <el-option
              v-for="subItem in themeTagList"
              :key="subItem.key"
              :label="subItem.value"
              :value="subItem.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 6手动输入 -->
      <el-form-item v-if="listXuan.paramType === '6'" label="手动输入对应的id：">
        <el-input
          @blur="onInputBlur(listXuan.value)"
          v-model="listXuan.value"
          clearable
          style="max-width:445px"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getHttps, getSee } from '@/api/demo/classification/index'
import { getListcu } from '@/api/demo/webTemplateEdit/index'
import { getMapList } from '@/api/demo/map'
import { replyContentOption } from '@/api/demo/helper'
import { tagOptions } from '@/api/demo/task'
export default {
  name: 'jumpType',
  props: {
    Jumpurls: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  watch: {
    Jumpurls: {
      handler (val) {
        console.log('dataObj deep change', val)
        this.listXuan = val
      },
      immediate: true // 初次监听即执行
    }
  },
  data () {
    return {
      listHttps: [], // 跳转链接
      listQuery: {
        // 装修页
        currentPage: 1,
        pageSize: 9999
      },
      listData: [], // 装修页数据
      listQusry: {
        // 商品分类
        currentPage: 1,
        pageSize: 20
      },
      listClass: [], // 商品分类
      // 打卡标签
      themeTagList: [],
      mapPageList: [],
      listXuan: {
        paramType: '0'
      },
      replyList: [],
      replyOptionLoading: false,
      form: {
        classId: ''
      }
    }
  },
  created () {
    let that = this
    // 获取跳转类型列表
    that.getgetHttpseD()
    // 查询商品分类列表
    that.getList()
    // 查询装修列表
    that.getListcD()
    that.getReplyList()
    that.getMapPageList()
    that.getThemeTagList()
  },

  methods: {
    getThemeTagList () {
      let that = this
      tagOptions().then(res => {
        that.themeTagList = res
      })
    },
    getReplyList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyContentOption(query).then(res => {
        that.replyList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    changeSkipType (item) {
      let that = this
      that.listXuan.paramType = item.paramType
      that.listXuan.id = item.id
      that.listXuan.url = item.url
      if (item) {
        that.listXuan.value = null
      }
      console.log('that.listXuan', item)
    },
    getMapPageList () {
      let that = this
      that.listQuery.currentPage = 1
      that.listQuery.pageSize = 100
      getMapList(that.listQuery).then(res => {
        that.mapPageList = res.records
      })
    },
    // 查询装修列表
    getListcD () {
      let that = this
      getListcu(that.listQuery).then(res => {
        that.listData = res.records
      })
    },
    // 查询商品分类列表
    getList () {
      let that = this
      getSee(that.listQuery).then(response => {
        for (let index = 0; index < response.records.length; index++) {
          if (response.records[index].state == 1) {
            that.listClass.push(response.records[index])
          }
        }
      })
    },
    // 数据列表
    getgetHttpseD () {
      let that = this
      getHttps().then(res => {
        that.listHttps = res
        console.log('listHttps', that.listHttps)
      })
    },
    onInputBlur (e) {
      let that = this
      if (that.listXuan.url) {
        let str = that.listXuan.url.substring(
          that.listXuan.url.lastIndexOf('=')
        )
        str = str.replace('=', '')
        let url = that.listXuan.url.replace(str, that.listXuan.value)
        that.listXuan.url = url
      }

      let url = that.listXuan.url.replace('${value}', that.listXuan.value)
      that.listXuan.url = url
      console.log('that.Jumpurls', that.listXuan)
    }
  }
}
</script>
